import axios from 'axios'
import store from '../../store'

let newDate = new Date().toISOString().slice(0, 10).split('-')
let yearNow = parseInt(newDate[0])  
if (yearNow <= 2500) { yearNow = yearNow + 543 }

let redCossDate = store.state.rcossYM
let lnameOwner = store.state.monkGet
let hostAPI = "./connectAPI/api_iservice.php?API="
if (!["stat.bora.dopa.go.th"].includes(window.location.hostname)) {
  hostAPI = ""
}

const funcs = {
  getListLnameDoc(yyyymmddBegin, yyyymmddEnd) {
    let hoststat =  "./connectAPI/statgen_forward.php?API="
    if (!["stat.bora.dopa.go.th"].includes(window.location.hostname)) {
      hoststat = ""
    }
    let sendAPI = hoststat + '/api/gen/statgen/v1/redcross/list/?yyyymmddBegin=' + yyyymmddBegin + '&yyyymmddEnd=' + yyyymmddEnd
    return new Promise((resolve, reject) => { 
      axios.get(sendAPI)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getListLname() {
    let sendAPI = hostAPI + '/api/gen/lname-reserve/v1/list?action=4&redcrossTime=' + redCossDate + '&lnameOwner=' + lnameOwner
    return new Promise((resolve, reject) => {
      axios.get(sendAPI)
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getDataPerson(pid) {
    let sendAPI = hostAPI + '/api/gen/lname-reserve/v1/?pid=' + pid + '&redcrossTime=' + redCossDate
    return new Promise((resolve, reject) => {
      axios.get(sendAPI)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          if (error.response.status === 404) {
            resolve(0)
          } else {
            resolve(error.response)
            reject(error)
          }
        })
    })
  },
  insertOwner(pid, lnameWrite, currentdate) {
    let sendAPI = hostAPI + '/api/gen/lname-reserve/v1/' + redCossDate + '/' + lnameOwner
    let sendAPI2 = hostAPI + '/api/gen/lname-reserve/v1/' + lnameWrite
    let docID = null
    return new Promise((resolve, reject) => {
      axios.get(sendAPI)
        .then(async function (response) {
          docID = response.data.docId
          store.state.docNo = docID
          await axios.put(sendAPI2, {
            reserve: {
              pid: pid,
              telNo: ' '
            },
            reserveDate: currentdate,
            reserveDocumentNo: docID,
            employeePid: '0',
            lnameOwner: lnameOwner,
            redcrossTime: redCossDate,
            upmEmp: '0'
          }, {
            headers: {
              'Content-type': 'application/json'
            }
          })
            .then(function (response2) {
              let res = response2.data
              resolve(res)
            })
            .catch(function (error2) {
              reject(error2.response.data.info)
            })
        })
        .catch(function (error) {
          resolve(error.response)
          reject(error)
        })
    })
  },
  cancereReserve(lnameWrite) {
    let sendAPI = hostAPI + '/api/gen/lname-reserve/v1/' + lnameWrite + '?action=1'
    return new Promise((resolve, reject) => {
      axios.put(sendAPI, {
        reserve: {
          pid: ' ',
          telNo: ' '
        },
        reserveDate: '',
        reserveDocumentNo: ' ',
        employeePid: ' ',
        lnameOwner: ' ',
        redcrossTime: ' ',
        upmEmp: ' '
      }, {
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then(function (response) {
          resolve(response.status)
        })
        .catch(function (error) {
          resolve(error.response)
          reject(error)
        })
    })
  }
}
export default funcs
